/**
 * Which material-specific design keys are WRITTEN onto an order line.
 *
 * DEFAULT_PRESCRIPTION_STATE seeds `deep.design.eva_thickness_mm` onto every
 * new prescription so a fresh EVA line carries the 2 mm default without the
 * operator opening the design card. The wizard keeps ONE design node for every
 * material, so without this rule that default would serialise onto PA12,
 * carbon and every other insole as well, and every reader would have to know
 * the value is meaningless there.
 *
 * The rule, in one place: only an EVA line stores `eva_thickness_mm`. The
 * caller decides what "is EVA" means, and buildLineConfiguration follows the
 * SUBTYPE whenever it knows it: the thickness control renders on the subtype
 * (InsoleDesignSection's eva_insole branch), while `configuration.material` is
 * a denormalised cache that can lag a subtype switch (the W2 residue), so
 * keying on material alone would delete the operator's pick in the very save
 * that rewrites material to 'EVA'. Material is only the fallback when no
 * subtype is known. WRITE side only, like deepForLineType: the form state is
 * never mutated, so an operator who switches EVA -> PA12 -> EVA keeps their
 * choice.
 */
import type { InsoleDesignState } from './prescription/prescriptionState';

export function designForMaterial(
  isEva: boolean,
  design: InsoleDesignState | undefined,
): InsoleDesignState | undefined {
  if (!design) return design;
  if (isEva) return design;
  if (!('eva_thickness_mm' in design)) return design;
  const kept: InsoleDesignState = { ...design };
  delete kept.eva_thickness_mm;
  return kept;
}
